import { render } from "./ethical-hero.vue?vue&type=template&id=6ebdf548&scoped=true"
import script from "./ethical-hero.vue?vue&type=script&lang=js"
export * from "./ethical-hero.vue?vue&type=script&lang=js"

import "./ethical-hero.vue?vue&type=style&index=0&id=6ebdf548&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebdf548"]])

export default __exports__